//  export const downloadReport = async (url, fileName) => {
//     try {
//       const response = await fetch(url, {
//         method: "GET",
//       });

//       if (!response.ok) throw new Error("Network response was not ok");

//       const blob = await response.blob();
//       const blobUrl = window.URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = fileName;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error("Download failed:", err);
//     }
//   };


export const downloadReport = (url, fileName) => {
  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.error("Download failed:", err);
  }
};